export default __webpack_public_path__ + "static/media/whitepapersix.ddb296ed.png";